import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiinnovacrystacab() {



const cardData = {
  keyword: " Pune to Mumbai Innova Crysta Cabs",

headingDescription:
  "Velocity Cab provides Pune to Mumbai Innova Crysta cab services, delivering a premium and comfortable travel experience for families, groups, and corporate travelers. Our professional drivers, well-maintained Toyota Innova Crysta vehicles, and punctual pickups ensure a smooth and stress-free journey from Pune to Mumbai. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Pune to Mumbai travel in an Innova Crysta.",

topPlaces: [
  
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is a vast green oasis within Mumbai, famous for its wildlife, cycling trails, boating, and lush forests. Booking an Innova Crysta on rent in Pune ensures a comfortable drive to this natural attraction, making it an excellent destination for families, adventure lovers, and nature enthusiasts."
  },
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens on Malabar Hill are beautifully landscaped terraced gardens offering panoramic views of the Arabian Sea and Marine Drive. Travelers choosing an Innova Crysta on rent in Pune can relax amidst well-maintained greenery, unique topiary displays, and peaceful surroundings while enjoying one of Mumbai's most scenic viewpoints."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is among Mumbai's most popular coastal attractions, known for its lively atmosphere, delicious street food, and spectacular sunsets. Visitors renting an Innova Crysta in Pune can comfortably travel to Mumbai and spend quality time enjoying beach walks, local snacks, and family-friendly entertainment."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is a remarkable meditation monument featuring one of the world's largest stone domes. Travelers booking an Innova Crysta on rent in Pune can enjoy a scenic drive to this peaceful destination near Gorai and experience meditation, spiritual learning, and impressive architecture surrounded by serene landscapes."
  },
  {
    title: "Flora Fountain",
    description: "Flora Fountain is a magnificent Victorian monument located in the heart of South Mumbai and surrounded by heritage buildings and bustling business districts. Travelers booking an Innova Crysta on rent in Pune can comfortably explore this iconic landmark while visiting nearby shopping streets, cafés, and colonial-era architecture. It is a great destination for history enthusiasts, photographers, and anyone interested in Mumbai's rich heritage."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive is one of Mumbai's most scenic waterfront promenades, offering breathtaking views of the Arabian Sea and the city's skyline. Visitors choosing an Innova Crysta on rent in Pune can enjoy a comfortable road trip before relaxing by the coastline, taking evening walks, and witnessing the famous sunset that makes Marine Drive one of Mumbai's top attractions."
  },
  {
    title: "Film City, Goregaon",
    description: "Film City in Goregaon is the center of India's entertainment industry and home to numerous Bollywood movie and television sets. Renting an Innova Crysta in Pune makes the journey convenient for families and groups interested in guided studio tours, film sets, and behind-the-scenes experiences of India's vibrant film industry."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's most vibrant shopping destinations, offering fashion accessories, handicrafts, antiques, cafés, and street food. Travelers hiring an Innova Crysta on rent in Pune can comfortably explore this lively market while enjoying local shopping and discovering the charm of South Mumbai."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a picturesque urban lake surrounded by gardens, restaurants, and modern city landmarks. Hiring an Innova Crysta on rent in Pune provides a smooth journey for families and groups looking to enjoy lakeside views, peaceful walks, boating, and quality leisure time in one of Mumbai's most attractive neighborhoods."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most iconic historical monument overlooking the Arabian Sea. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this famous landmark, admire its magnificent architecture, enjoy ferry rides to nearby attractions, and capture unforgettable photographs at one of India's most recognized tourist destinations."
  }
],



services: [
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service offers premium SUV transportation between Pune and Mumbai. The Toyota Innova provides spacious seating, smooth ride quality, and comfortable interiors suitable for long-distance expressway travel. Professional drivers ensure safe driving and punctual pickup services from homes, offices, hotels, and railway stations across Pune."
},
{
name: "Pune to Mumbai Airport Drop Innova",
description: "Pune to Mumbai Airport drop Innova service provides reliable airport transportation using spacious SUV vehicles. The Innova offers comfortable seating and luggage space suitable for airport journeys. Professional drivers ensure timely pickup and safe expressway travel to Chhatrapati Shivaji Maharaj International Airport terminals."
},
{
name: "Pune Mumbai Innova Rental",
description: "Pune Mumbai Innova rental service offers flexible SUV hire for travelers planning trips between Pune and Mumbai. The Innova vehicle provides spacious seating for families and small groups. Ideal for corporate travel, airport transfers, and tourism trips."
},
{
name: "Pune to Mumbai Airport Innova",
description: "Pune to Mumbai Airport Innova cab service provides dependable airport transportation using premium SUV vehicles. Comfortable seating, luggage space, and professional drivers ensure smooth and safe expressway travel."
},
{
name: "Innova Crysta on Rent Pune",
description: "Innova Crysta on rent in Pune offers luxury SUV rental for passengers seeking comfortable and spacious transportation. The premium vehicle is suitable for family trips, airport transfers, corporate travel, and long-distance journeys."
},
{
name: "Pune to Mumbai One Way Innova Taxi",
description: "Pune to Mumbai one way Innova taxi service offers convenient single-trip transportation between Pune and Mumbai. The spacious SUV ensures comfortable expressway travel with professional drivers providing safe journeys."
},
{
name: "Pune to Mumbai Darshan Innova Taxi",
description: "Pune to Mumbai darshan Innova taxi service offers sightseeing travel options for visitors planning to explore famous locations in Mumbai. The Innova SUV provides spacious seating and smooth city travel."
},
{
name: "Pune to Dadar Innova Taxi Fare",
description: "Pune to Dadar Innova taxi fare services provide transparent pricing for travelers traveling between Pune and Mumbai’s Dadar area. The premium SUV offers comfortable seating suitable for long-distance expressway travel."
},
{
name: "Pune to Andheri Innova Crysta",
description: "Pune to Andheri Innova Crysta cab service offers premium SUV transportation between Pune and Mumbai’s Andheri area. The Innova Crysta provides spacious seating and luxury interiors suitable for highway travel."
},
{
name: "Pune to Mumbai Round Trip Innova Crysta",
description: "Pune to Mumbai round trip Innova Crysta cab service offers convenient travel options for passengers planning same-day or multi-day return journeys. The premium SUV ensures smooth and comfortable expressway travel."
},
{
name: "Pune to Mumbai Airport Innova Crysta Cab",
description: "Pune to Mumbai Airport Innova Crysta cab service provides luxury airport transportation using premium SUV vehicles. Spacious seating and luggage space ensure comfortable travel to Mumbai Airport terminals."
},
{
name: "Pune to Mumbai Airport Drop Innova",
description: "Pune to Mumbai Airport drop Innova service offers reliable one-way transportation for airport travelers. Professional drivers ensure safe driving and punctual pickup from Pune city."
},
{
name: "Innova Hire in Pune",
description: "Innova hire in Pune provides comfortable SUV transportation for city travel, airport transfers, and outstation journeys. The spacious vehicle is suitable for families, corporate groups, and tourism travel."
},
{
name: "8 Seater Innova on Rent Pune",
description: "8 seater Innova on rent in Pune offers spacious transportation for families and groups. The vehicle provides comfortable seating and luggage capacity suitable for long-distance highway travel."
},
{
name: "7 Seater Innova on Rent in Pune",
description: "7 seater Innova on rent in Pune provides comfortable SUV transportation for family trips and airport transfers. The vehicle offers spacious interiors and smooth highway travel performance."
},
{
name: "Innova Per Km Rate for Outstation",
description: "Innova per km rate for outstation services provide transparent pricing for travelers planning long-distance journeys from Pune. The premium SUV offers comfortable seating and smooth travel for highway trips."
},
{
name: "Innova Crysta on Rent in Pimpri Chinchwad",
description: "Innova Crysta on rent in Pimpri Chinchwad provides luxury SUV rental for travelers seeking comfortable transportation. The vehicle is suitable for airport transfers, corporate travel, and outstation trips."
},
{
name: "Velocity Cabs Pune",
description: "Velocity Cabs Pune offers dependable transportation services for local travel, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe and convenient rides."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for city rides, airport transfers, and long-distance journeys. Vehicles are comfortable and suitable for daily commuting and highway travel."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides dependable airport transportation for passengers traveling from Pune city to Mumbai Airport terminals. Comfortable vehicles ensure safe expressway travel."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Pune to Shirdi Innova Crysta Cab on Rent",
description: "Pune to Shirdi Innova Crysta cab on rent service provides comfortable SUV transportation for pilgrims traveling to Shirdi. The premium vehicle offers spacious seating suitable for family trips."
},
{
name: "Pune to Shirdi Innova Crysta Cab Booking Online",
description: "Pune to Shirdi Innova Crysta cab booking online service allows travelers to easily reserve premium SUV transportation for Shirdi trips. Comfortable seating and professional drivers ensure smooth highway travel."
},
{
name: "Pune to Mumbai Innova Crysta Cab",
description: "Pune to Mumbai Innova Crysta cab service offers luxury SUV transportation between Pune and Mumbai. The premium vehicle ensures comfortable seating and smooth expressway travel."
},
{
name: "Pune to Mumbai Innova Crysta Taxi",
description: "Pune to Mumbai Innova Crysta taxi service provides reliable premium SUV transportation for travelers heading from Pune to Mumbai. Spacious seating and professional drivers ensure safe journeys."
}
],

tableData: [
["Pune to Mumbai Innova Cab","Pune to Mumbai Airport Drop Innova"],
["Pune Mumbai Innova Rental","Pune to Mumbai Airport Innova"],
["Innova Crysta on Rent Pune","Pune to Mumbai One Way Innova Taxi"],
["Pune to Mumbai Darshan Innova Taxi","Pune to Dadar Innova Taxi Fare"],
["Pune to Andheri Innova Crysta","Pune to Mumbai Round Trip Innova Crysta"],
["Pune to Mumbai Airport Innova Crysta Cab","Pune to Mumbai Airport Drop Innova"],
["Innova Hire in Pune","8 Seater Innova on Rent Pune"],
["7 Seater Innova on Rent in Pune","Innova Per Km Rate for Outstation"],
["Innova Crysta on Rent in Pimpri Chinchwad","Velocity Cabs Pune"],
["Cab Service in Pune","Pune to Mumbai Airport Cab"],
["Pune Mumbai Cab","Pune to Shirdi Innova Crysta Cab on Rent"],
["Pune to Shirdi Innova Crysta Cab Booking Online","Pune to Mumbai Innova Crysta Cab"],
["Pune to Mumbai Innova Crysta Taxi","Pune to Mumbai Innova Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Luxury Innova Crysta Travel Experience",
    WhyChoosedescription: "Velocity Cabs offers premium Innova Crysta cab services for Pune to Mumbai travel. The Innova Crysta provides luxury seating, spacious interiors, and smooth highway performance making it ideal for comfortable long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides professional drivers who regularly travel on the Mumbai Pune Expressway. Their experience with highway routes ensures safe driving and timely arrival for Pune to Mumbai travel."
  },
  {
    WhyChooseheading: "Transparent Innova Crysta Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and competitive pricing for Pune to Mumbai Innova Crysta cab bookings. Customers receive full fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Pune to Mumbai Innova Crysta cab service operates 24 hours a day. Whether you need airport transfers, corporate travel, or late night rides, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Crysta Vehicles",
    WhyChoosedescription: "All Innova Crysta vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a premium travel experience."
  },
  {
    WhyChooseheading: "Ideal for Family & Corporate Travel",
    WhyChoosedescription: "The Innova Crysta cab is perfect for families, business travelers, and small groups traveling from Pune to Mumbai. It offers comfortable seating and sufficient luggage space for long-distance trips."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "Velocity Cabs provides convenient doorstep pickup from homes, offices, hotels, and railway stations across Pune including Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, and Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Trusted Intercity Luxury Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Pune to Mumbai Innova Crysta cab bookings thanks to punctual drivers, premium vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Pune to Mumbai Innova Crysta cab service?", answer: "Yes, Velocity Cabs provides premium Innova Crysta cab services from Pune to Mumbai for comfortable long-distance travel." },
  { question: "How many passengers can travel in an Innova Crysta?", answer: "An Innova Crysta can comfortably accommodate up to 6 or 7 passengers along with luggage." },
  { question: "Is Pune to Mumbai Innova Crysta cab service available 24 hours?", answer: "Yes, our Innova Crysta cab service operates 24/7 for Pune to Mumbai travel." },
  { question: "Can I book a one-way Innova Crysta cab from Pune to Mumbai?", answer: "Yes, Velocity Cabs provides both one-way and round-trip Innova Crysta cab services between Pune and Mumbai." },
  { question: "Do you provide pickup from Pune Airport or railway station?", answer: "Yes, our drivers provide pickup from Pune Airport, railway stations, homes, offices, and hotels across Pune." },
  { question: "Are Innova Crysta vehicles air-conditioned?", answer: "Yes, all Innova Crysta vehicles provided by Velocity Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book Pune to Mumbai Innova Crysta cab online?", answer: "Yes, customers can easily book Innova Crysta cabs online or through phone booking with Velocity Cabs." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and peak travel periods." },
  { question: "Do you provide Mumbai Airport drop?", answer: "Yes, Velocity Cabs provides direct drop service to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "A premium and very comfortable Pune to Mumbai journey in the Innova Crysta. The ride quality was excellent, and the vehicle felt spacious and well-maintained throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback:
      "The Innova Crysta made the Pune to Mumbai travel extremely smooth and relaxing. Seating comfort was top-notch, and the overall experience felt safe and hassle-free.",
    rating: 5
  }
];






































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Innova Crysta Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers Pune to Mumbai Innova Crysta cab service with affordable fares and professional drivers. Book one way and round trip Innova taxis for airport transfers, Dadar, Andheri, Mumbai airport, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Pune to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
     <Helmet>
  <title>Pune to Mumbai Innova Crysta Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Innova Crysta cab with Velocity Cabs. Affordable one way, round trip & airport drop Innova taxis for Dadar, Andheri & Mumbai airport. Safe and reliable cab service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet> 


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiinnovacrystacab;